import Controller from '@ember/controller';
import { tracked } from 'tracked-built-ins';

export default class CommunicationsSettingsController extends Controller {
  @tracked messageCategoriesSettingsExpanded: boolean = false;
}
